export default "__VITE_ASSET__DesZQ1RC__"